import { DatePicker, type DatePickerProps } from "@mui/x-date-pickers";
import { forwardRef, useState } from "react";
import { BaseTextField } from "../base-text-field";

function NoIcon() {
  return null; // 何も描画しない
}

export const BaseDatePicker = forwardRef(
  (
    props: Pick<DatePickerProps<Date>, "value" | "disabled"> & {
      onChange: (value: Date | undefined) => void;
      error?: boolean;
      helperText?: string;
    },
    ref: React.Ref<HTMLDivElement>,
  ) => {
    const { error, disabled, helperText, onChange, value, ...rest } = props;
    const [open, setOpen] = useState(false);

    return (
      <DatePicker
        ref={ref}
        open={open}
        value={value ?? null}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        slotProps={{
          textField: {
            size: "small",
            error,
            helperText,
            placeholder: "日付を選択",
            onClick: () => {
              setOpen(true);
            },
            onFocus: (e) => {
              e.target.blur();
            },
            sx: {
              minWidth: { xs: "auto", sm: 180 },
            },
          },
        }}
        slots={{
          textField: BaseTextField,
          openPickerIcon: NoIcon,
          // [モバイルのみ]
          // 選んだ日付が上に出てしまうのを防ぐため非表示にする
          toolbar: () => null,
        }}
        format="yyyy年MM月dd日"
        {...rest}
        onChange={(date) => {
          onChange(date ?? undefined);
        }}
      />
    );
  },
);
